import LOGO from "../images/quintanas.png";

export const Team__LosQuintanas = {
  name: "Los Quintanas",
  logoImage: LOGO,
  teamImage: null,
  teamLogoColor: "#88cc2fff",
  teamJerseyColor: "#162500ff",

  // Stats
  gamesWon: 1,
  gamesLost: 2,
  gamesTied: 0,
  gamesTiedWon: 0,

  ownGoalsInFavor: 0,
  goalsScoredAgainst: 53 + 39 + 36,
  defaultGoals: 0,

  isChampion: false,
  isEliminated: false,

  players: [
    {
      goalsScored: 28 + 25 + 48,
    },
  ],
};
